import React from 'react';
import ThemeToggle from '../../ui/ThemeToggle';
import LanguageToggle from '../../ui/LanguageToggle';
import FontSizeToggle from '../../ui/FontSizeToggle';
import './FloatingControls.css';

const FloatingControls = () => {
    return (
        <div className="floating-controls confirm-pill">
            <ThemeToggle />
            <div className="divider"></div>
            <LanguageToggle />
            <div className="divider"></div>
            <FontSizeToggle />
        </div>
    );
};

export default React.memo(FloatingControls);
